import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SupplierAddress, SupplierAddressCreate, SupplierAddressFilter } from '../data/supplierAddress';

export function createSupplierAddressService(client: AxiosInstance) {
  return createCrudService<SupplierAddress, SupplierAddressCreate, SupplierAddressFilter>(
    client,
    '/purchase/SupplierAddress',
    'id',
  );
}

export type SupplierAddressService = CrudService<SupplierAddress, SupplierAddressCreate, SupplierAddressFilter>;
